import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AuthService} from '@core/auth/auth.service';
import {LoaderComponent} from '@core/components/loader/loader.component';
import {ButtonModule} from 'primeng/button';
import {SidebarService} from './sidebar.service';
import {SidebarComponent} from './sidebar/sidebar.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, CommonModule, LoaderComponent, ButtonModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent implements OnInit {
  constructor(
    public sidebarService: SidebarService,
    public auth: AuthService
  ) {}

  ngOnInit(): void {
    if (this.auth.getToken()) {
      this.auth.getProfile().subscribe({
        error: () => {
          // handled by interceptor
        },
      });
    }
  }

  toggleSidebar(): void {
    this.sidebarService.toggleSidebar();
  }

  logout(): void {
    this.auth.logout();
  }
}
